import React from 'react';
import clsx from 'clsx';
import { IconAlert, IconInfo, IconError, IconCheckMark, } from '../../internal/icons';
import { bannerClasses } from './style';
export function getBannerIconNode(props) {
    const { type, icon } = props;
    let IconComp = (React.createElement(IconInfo, { className: clsx(bannerClasses.icon, bannerClasses.iconInfo) }));
    if (icon) {
        IconComp = React.cloneElement(icon, {
            className: clsx([icon.props.className, bannerClasses.icon]),
        });
    }
    else if (type === 'success') {
        IconComp = (React.createElement(IconCheckMark, { className: clsx(bannerClasses.icon, bannerClasses.iconSuccess) }));
    }
    else if (type === 'warn' || type === 'warning') {
        IconComp = (React.createElement(IconAlert, { className: clsx(bannerClasses.icon, bannerClasses.iconWarn) }));
    }
    else if (type === 'error') {
        IconComp = (React.createElement(IconError, { className: clsx(bannerClasses.icon, bannerClasses.iconError) }));
    }
    return IconComp;
}
